export const STORE_CUSTOMER_DETAIL: string = 'CUSTOMER/STORE_CUSTOMER_DETAIL';
export const CLEAR_CUSTOMER_DETAIL: string = 'CUSTOMER/CLEAR_CUSTOMER_DETAIL';
